var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWallet = function SvgIconWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.282 5.57a.9.9 0 0 1 .343-.07H18a1 1 0 1 0 0-2H5.625A2.877 2.877 0 0 0 2.75 6.456V18a2.5 2.5 0 0 0 2.5 2.5h15A1.75 1.75 0 0 0 22 18.75V9a1.75 1.75 0 0 0-1.75-1.75H5.661a.903.903 0 0 1-.91-.839v-.036l-.001-.033a.88.88 0 0 1 .532-.773M4.75 18V9.107c.297.097.61.146.927.143H20v9.25H5.25a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  }))));
};
export default SvgIconWallet;